<template>
    <div class="popup-animations">
        <confetti-animation v-if="animation === 'confetti'" />
        <moon-sun v-if="animation === 'moon-sun'" :element="element" />
    </div>
</template>

<script>
import ConfettiAnimation from '@/assets/animations/confetti-animation';
const MoonSun = () => import('@/components/popups/popup-elements/integration/moon-sun');

export default {
    name: 'popup-animations',

    components: {
        'confetti-animation': ConfettiAnimation,
        'moon-sun' : MoonSun
    },

    props: {
        animation: {
            type: String,
            default: null
        },

        element: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
        }
    },

    computed: {
    },

    methods: {
    }
}
</script>

<style>
.popup-animations{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    pointer-events: none;
}
.popup-animations .vue-lottie-player {
    background: transparent;
    height: 100%;
}
</style>
